import { KanbanTaskCardHeader } from '../../components/kanban/kanban-task-card-header.tsx';
import { Button } from '@progress/kendo-react-buttons';
import { KanbanTaskCard } from '../../components/kanban/kanban-task-card.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import type { SamplerTaskCardProps } from './sampler-task-card.types.ts';
import { KanbanTaskCardBody } from '../../components/kanban/kanban-task-card-body.tsx';
import { Label } from '@progress/kendo-react-labels';
import styles from './sampler-task-card.module.scss';

export function SamplerTaskCard(props: SamplerTaskCardProps) {
  const handleClick = () => {
    if (props.onOpenDialog) props.onOpenDialog({ sampler: props.data });
  };

  return (
    <KanbanTaskCard className={styles.card} {...props}>
      <KanbanTaskCardHeader>
        <span className={styles.headerTitle}>
          {props.data.forename} {props.data.surname}
        </span>
        <div>
          <Button className={styles.headerBtn} onClick={handleClick}>
            <FontAwesomeIcon icon={faPencil} size={'1x'} />
          </Button>
        </div>
      </KanbanTaskCardHeader>
      <KanbanTaskCardBody>
        <Label>Working Days:</Label>
        <span>{props.data.weeklyWorkdays}</span>
        <Label>Daily Samples:</Label>
        <span>{props.data.weeklySampleEstimate}</span>
      </KanbanTaskCardBody>
    </KanbanTaskCard>
  );
}
